import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import LoadingMainPage from "./Common/Loading/LoadingMainPage";
import { ClientContext } from "./Context/Context";

const PublicRoute = ({ children }) => {
  const { clientIsLoggedIn, clientIsLoading } = useContext(ClientContext);

  // if (clientIsLoggedIn) {
  //   console.log("Cliente logeado");
  //   // return <Navigate to="/panel" replace />;
  // } else {
  //   console.log("No esta logeado");
  // }

  const content = children || <Outlet />;

  return (
    <>
      <LoadingMainPage
        isLoading={clientIsLoading}
        logoVariant="letters"
        minVisibleMs={4000}
      />
      {!clientIsLoading ? content : null}
    </>
  );
};

export default PublicRoute;
